import React from 'react'
import ReactDOM from 'react-dom'
import Payment from './PaymentComponent'

export default function({
  amount,
  currency,
  color,
  text,
  accept,
  connected,
  errorText,
  test,
  wallets,
  whitelist,
  error,
  backUrl,
}) {
  ReactDOM.render(
    <Payment
      amount={ amount }
      currency={ currency }
      color={ color }
      text={ text }
      accept={ accept }
      connected={ connected }
      errorText={ errorText }
      test={ test }
      wallets={ wallets }
      whitelist={ whitelist }
      error={ error }
      backUrl={ backUrl }
    />, document.getElementById('payment'))
}
